<template>
  <div class="wrapper">
    <v-head></v-head>
    <v-sidebar></v-sidebar>
    <div class="content-box" :class="{'content-collapse':collapse}">
      <div class="content">
        <v-breadcrumb></v-breadcrumb>
        <transition name="move" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from './header.vue';
import vSidebar from './sidebar.vue';
import vBreadcrumb from './breadcrumb.vue'
import bus from './bus';
import commonFun from '@/utils/commonFun';
import { refreshICList, refreshMenu, setICList } from "@/store/main";
import { inputChoiceService } from "@/api/common/input-choice";

export default {
  data() {
    return {
      tagsList: [],
      collapse: false
    }
  },
  components: {
    vHead, vSidebar, vBreadcrumb
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log("🚀 ~ file: home.vue:42 ~ val:", val)
        inputChoiceService.listInputChoice().then((res) => {
          let inputChoiceList = res.data;
          let icData = {};
          inputChoiceList.forEach((ic) => {
            if (!(icData.hasOwnProperty(ic.tableName))) {
              icData[ic.tableName] = {};
            }
            if (!(icData[ic.tableName].hasOwnProperty(ic.fieldName))) {
              icData[ic.tableName][ic.fieldName] = {};
            }
            icData[ic.tableName][ic.fieldName][ic.code] = { chineseValue: ic.chineseValue, seq: ic.seq, englishValue: ic.englishValue };
          });
          // context.commit(setICList, icData);
          this.$store.commit(setICList, icData);
        })
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    name() {
      return commonFun.getICVal("TM_ROLE", "ROLE_APP_TYPE", "0");
    }
  },
  created() {
    this.$store.dispatch(refreshICList);
    this.$store.dispatch(refreshMenu);

    bus.$on('collapse', msg => {
      this.collapse = msg;
    })
  },
}
</script>
